import { RouterOutputs, trpc } from "../trpc";

export type ExportZapsResponse = RouterOutputs["zap"]["export"];

export function useExportZaps() {
  const mutation = trpc.zap.export.useMutation({
    onSuccess: (exportedZaps) => {
      return exportedZaps;
    },
  });

  return {
    exportZaps: mutation.mutate,
    isLoading: mutation.isPending,
  };
}
